import { BaseComponent } from '../base-component/base-component';
import { customElement, property } from 'lit/decorators.js';
import { getDateFromTimestamp } from '../../common/utils/date-utils';
import { html, nothing } from 'lit';
import { FreeTrialInfo, FreeTrialStatus } from './interfaces/free-trial-info.interface';

export const ACTIVE_MESSAGE = 'Free Trial Through';
export const CANCELLED_MESSAGE = 'Free Trial Canceled -';
export const EXPIRED_MESSAGE = 'Free Trial Expired -';

/**
 * A static element to display free trial end date.
 */
@customElement('mhecomm-free-trial-end-date')
export class FreeTrialEndDate extends BaseComponent {
  /**
   * Additional CSS classes for the end date label.
   */
  @property()
  addClass = '';

  /**
   * A JSON String in the format of 'FreeTrialInfo'.
   */
  @property({type: Object})
  freeTrial?: FreeTrialInfo;

  /**
   * Renders the end date of the free trial.
   */
  renderComp() {
    return html`
      ${this.freeTrial?.isFreeTrial && this.freeTrial?.endDate
        ? html`
          <span part="free-trial-end-date"
              class="mb-2 align-items-center justify-content-center badge ${this._getBadgeStyle()} text-wrap ${this.addClass}"
          >
            ${this._getMessage()}
          </span>`
        : nothing}
    `;
  }

  _getMessage(): string {
    return `${this._getText()} ${this._getDate()}`;
  }

  _getDate(): string {
    const date = this.freeTrial?.status === FreeTrialStatus.CANCELED
      ? this.freeTrial.cancelDate
      : this.freeTrial?.endDate;
    return date ? getDateFromTimestamp(date) : ''
  }

  _getText(): string {
    switch (this.freeTrial?.status) {
      case FreeTrialStatus.CANCELED:
        return CANCELLED_MESSAGE;
      case FreeTrialStatus.EXPIRED:
        return EXPIRED_MESSAGE;
      case FreeTrialStatus.ACTIVE:
        return ACTIVE_MESSAGE;
      default:
        return ACTIVE_MESSAGE;
    }
  }

  _getBadgeStyle(): string {
    switch (this.freeTrial?.status) {
      case FreeTrialStatus.CANCELED:
      case FreeTrialStatus.EXPIRED:
        return 'bg-danger';
      case FreeTrialStatus.ACTIVE:
        return 'bg-warning text-dark';
      default:
        return 'bg-warning text-dark';
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-free-trial-end-date': FreeTrialEndDate;
  }
}
